import React, { useState } from 'react';
import { Box, Typography, Modal } from '@mui/material';
import styles from './styles';
import Button from '../Button/Button';

interface ConfirmActionModalProps {
  confirmationMessage: string;
  secondaryConfirmationMessage?: string;
  action: () => Promise<void>;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isDelete?: boolean;
}

function ConfirmActionModal({
  confirmationMessage,
  secondaryConfirmationMessage,
  action,
  open,
  setOpen,
  isDelete
}: ConfirmActionModalProps): React.ReactElement | null {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = (): void => setOpen(false);

  const handleCancelClick = (event: React.MouseEvent): void => {
    event.stopPropagation();
    setOpen(false);
  };

  const handleModalClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
  };

  const handleConfirm = async (event: React.MouseEvent): Promise<void> => {
    event.stopPropagation();
    setIsLoading(true);
    try {
      await action();
      setOpen(false);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmBtnText = isDelete ? 'Yes, delete' : 'Yes';

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='confirmation-message-label'
      onClick={handleModalClick}
    >
      <Box sx={styles.modal} onClick={handleModalClick}>
        <Typography variant='h3' sx={styles.header}>
          Are you sure?
        </Typography>
        <Box sx={styles.content}>
          <Typography variant='body2' id='confirmation-message-label'>
            {confirmationMessage}
          </Typography>
          {secondaryConfirmationMessage && (
            <Typography
              variant='body2'
              id='secondary-confirmation-message-label'
            >
              {secondaryConfirmationMessage}
            </Typography>
          )}
        </Box>
        <Box sx={styles.buttonContainer}>
          <Button variant='ghost' onClick={handleCancelClick}>
            Cancel
          </Button>
          <Button
            variant='ghost'
            loading={isLoading}
            className={isDelete ? 'w-40' : 'w-24'}
            onClick={handleConfirm}
          >
            {confirmBtnText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default ConfirmActionModal;
